import script from "./BalanceStar.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceStar.vue?vue&type=script&setup=true&lang=js"

import "./BalanceStar.vue?vue&type=style&index=0&id=0e36458a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e36458a"]])

export default __exports__